export default __webpack_public_path__ + "media/quote/reel-loop-402076c9.mp4";